var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import ModalOptionsCardAPI from './modal-option-card-api';
import React, { Component } from 'react';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { Card, Text } from '@philips-internal/oswald-ui-components/lib/components';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import './modal-option-card.css';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
let ModalOptionsCard = class ModalOptionsCard extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { modelSuepDescription, modelSuepSequence, onClick, } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        modelSuepDescription,
                        modelSuepSequence
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener
    }; }
    renderData() {
        const { modelSuepDescription } = this.props;
        return (React.createElement("div", { className: 'c-modal-card__cn-data' },
            React.createElement(Text, { value: modelSuepDescription })));
    }
    render() {
        const { modelSuepSequence } = this.props;
        return (React.createElement(Card, { className: 'c-modal-main', selectionType: SelectionType.SINGLE, width: 12, onClick: this.handleClick, uuid: generateUUID(), key: modelSuepSequence },
            React.createElement("div", { className: 'c-modal-card__cn-wrapper', onClick: () => this.handleClick() }, this.renderData())));
    }
};
ModalOptionsCard = __decorate([
    AwesomeComponent({ api: ModalOptionsCardAPI, type: ComponentType.DATA_DISPLAY })
], ModalOptionsCard);
export default ModalOptionsCard;
//# sourceMappingURL=modal-option-card.js.map